import { render, staticRenderFns } from "./wy-filter-item-integer.vue?vue&type=template&id=0c9b1ffe&scoped=true&"
import script from "./wy-filter-item-integer.vue?vue&type=script&lang=js&"
export * from "./wy-filter-item-integer.vue?vue&type=script&lang=js&"
import style0 from "./wy-filter-item-integer.vue?vue&type=style&index=0&id=0c9b1ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9b1ffe",
  null
  
)

export default component.exports